module.exports = __webpack_public_path__ + "files/7f462f12cce083953dfdf409759f09fd.png";